module.exports = __webpack_public_path__ + "static/logo-nextjs-3a43664facde6ed470b94f98eec315ff.png";